import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { MoreInfo } from 'components/icons';
import RecommendedSizeTooltip from 'components/productdetail/stylepicker/RecommendedSizeTooltip';
import { RecommendedSizeFinderModal } from 'components/productdetail/asyncProductPageModals';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import css from 'styles/components/productdetail/recommendedSizing.scss';

// This component only shows up on desktop (see css.recommendedFit)
export const RecommendedSizeInfo = () =>
  <div className={css.recommendedFit}>
    <strong>Recommended Fit</strong>
    <MoreInfo/>
  </div>;

export const RecommendedSizeButton = props => {
  const { openModal, describedby } = props;
  return <button
    type="button"
    aria-describedby={describedby}
    className={css.calculateSize}
    onClick={openModal}
  >
    Calculate Your Size!
  </button>;
};

export const RecommendedSizeIndicator = props => {
  const { predictedSize, selectedSize } = props;
  return <>
    <MoreInfo className={css.sizeIndicatorIcon} />
    <span>{`Your recommended size is ${selectedSize === predictedSize ? 'selected' : predictedSize}`}</span>
  </>;
};

const tooltipId = 'recommendedSizeTooltip';
export const TooltipStyleRecommendedSizing = ({ predictedSize, selectedSize, onOpenModal }) => (
  predictedSize ?
    <RecommendedSizeIndicator selectedSize={selectedSize} predictedSize={predictedSize}/>
    : <>
      <RecommendedSizeInfo />
      <RecommendedSizeTooltip id={tooltipId} openModal={onOpenModal} />
      <RecommendedSizeButton describedby={tooltipId} openModal={onOpenModal} />
    </>
);

export const LinkStyleRecommendedSizing = ({ predictedSize, selectedSize, onOpenModal,isDesktopView, onDemandSizingCopy = {} }) => {
  const bothSizesSelected = predictedSize && selectedSize;
  const tooltipId = 'recommendedSizeTooltip';
  const {
    ignoredcopy, ignoredimage,
    selectedcopy, selectedimage,
    availablecopy, availableimage
  } = onDemandSizingCopy;

  if (bothSizesSelected && selectedSize !== predictedSize && ignoredcopy) {
    return <p style={ignoredimage && { 'backgroundImage': `url('${ignoredimage}')` }} className={css.linkStyleCopy}>{ignoredcopy.replace(/%s/g, predictedSize)}</p>;
  } else if (bothSizesSelected && selectedSize === predictedSize && selectedcopy) {
    return <p style={selectedimage && { 'backgroundImage': `url('${selectedimage}')` }} className={css.linkStyleCopy}>{selectedcopy}</p>;
  } else if (availablecopy) {
    return (
      <>
        { isDesktopView === true && <RecommendedSizeTooltip id={tooltipId} openModal={onOpenModal} /> }
        <button
          style={availableimage && { 'backgroundImage': `url('${availableimage}')` }}
          className={css.linkStyleCopy}
          type="button"
          describedby={tooltipId}
          onClick={onOpenModal}>
          {availablecopy}
        </button>
      </>
    );
  } else {
    return null;
  }
};

export const RecommendedSizing = props => {
  const {
    predictedSize,
    selectedSize,
    onOpenModal,
    onCloseModal,
    handleSetRecommendedFit,
    gender,
    product : { detail : { productId } },
    onDemandSize,
    handleCalculateSizeClick,
    isOnDemandSizingModalOpen,
    location,
    hydraPdpOdspLinkChange,
    isDesktopView,
    onDemandSizingCopy
  } = props;

  return (
    <div className={css.recommendedFitContainer}>
      {hydraPdpOdspLinkChange ?
        <LinkStyleRecommendedSizing
          predictedSize={predictedSize}
          selectedSize={selectedSize}
          onOpenModal={onOpenModal}
          isDesktopView={isDesktopView}
          onDemandSizingCopy={onDemandSizingCopy}/>
        : <TooltipStyleRecommendedSizing
          openModal={onOpenModal}
          predictedSize={predictedSize}
          selectedSize={selectedSize}
          onOpenModal={onOpenModal}/>
      }
      {isOnDemandSizingModalOpen && <RecommendedSizeFinderModal
        productId={productId}
        gender={gender}
        onSetRecommendedFit={handleSetRecommendedFit}
        onClose={onCloseModal}
        location={location}
        onDemandSize={onDemandSize}
        handleCalculateSizeClick={handleCalculateSizeClick}
        isOpen={isOnDemandSizingModalOpen}
        predictedSize={predictedSize}/>
      }
    </div>
  );
};

RecommendedSizing.propTypes = {
  gender: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  handleSetRecommendedFit: PropTypes.func,
  predictedSize: PropTypes.string,
  selectedSize: PropTypes.string,
  hydraPdpOdspLinkChange: PropTypes.bool,
  onDemandSizingCopy: PropTypes.object
};

const ConnectedRecommendedSizing = connect(state => {
  const {
    product: { sizingPredictionValue },
    sizingChooser: { sizingChooser : { recommendedFit } },
    headerFooter: { content: { Global: { slotData: { onDemandSizingCopy } } = {} } = {} } } = state;
  return {
    predictedSize : recommendedFit || sizingPredictionValue || '',
    onDemandSizingCopy
  };
})(RecommendedSizing);

export default withErrorBoundary('ConnectedRecommendedSizing', ConnectedRecommendedSizing);
